import React, { FC, ReactNode } from "react";
import clsx from "clsx";
import styles from "./toast.module.scss";
import { ReactComponent as CloseIcon } from "Assets/icon/icon-delete.svg";
import { IconButton } from "../IconButton";
import { useTranslation } from "lib/i18n/use-translation";

export interface ToastPropsType {
  messageHeader?: string;
  message: string;
  closeToast?: () => void;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  showCloseButton?: boolean;
  className?: string;
  contentClassName?: string;
  variant?: "default" | "success" | "error" | "warning" | "info";
  size?: "small" | "medium" | "large";
}

export const Toast: FC<ToastPropsType> = ({
  messageHeader,
  message,
  closeToast,
  icon,
  iconPosition = "left",
  className,
  contentClassName,
  variant = "default",
  size = "small",
}) => {
  const { t } = useTranslation("components");

  return (
    <div
      className={clsx(
        styles["toast-container"],
        styles[`toast-${variant}`],
        styles[`toast-${size}`],
        className
      )}
    >
      <div className={styles["toast-content-container"]}>
        <div className={clsx(styles["toast-content"], contentClassName)}>
          {icon && iconPosition === "left" && icon}
          <div className={styles["toast-text"]}>
            {messageHeader && (
              <p className={styles["toast-header-text"]}>{messageHeader}</p>
            )}
            <p className={styles["toast-message"]}>{message}</p>
          </div>
          {icon && iconPosition === "right" && icon}
        </div>
        {closeToast && (
          <IconButton
            icon={<CloseIcon />}
            onClick={closeToast}
            aria-label={t("components:toast.closeA11y")}
            variant="enclosed-secondary"
            monochromeColour="white"
            className={styles["toast-close-button"]}
            size="small"
          />
        )}
      </div>
    </div>
  );
};
